/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { agentGetConfiguration } from "../funcs/agentGetConfiguration.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { DeviceAgentConfiguration } from "../models/components/deviceagentconfiguration.js";
import {
  GetDeviceAgentConfigurationRequest,
  GetDeviceAgentConfigurationSecurity,
} from "../models/operations/getdeviceagentconfiguration.js";
import { unwrapAsync } from "../types/fp.js";
export type DeviceAgentConfigurationQueryData = DeviceAgentConfiguration;

export function prefetchDeviceAgentConfiguration(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetDeviceAgentConfigurationRequest | undefined,
  security?: GetDeviceAgentConfigurationSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildDeviceAgentConfigurationQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildDeviceAgentConfigurationQuery(
  client$: GramCore,
  request?: GetDeviceAgentConfigurationRequest | undefined,
  security?: GetDeviceAgentConfigurationSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<DeviceAgentConfigurationQueryData>;
} {
  return {
    queryKey: queryKeyDeviceAgentConfiguration({
      gramSession: request?.gramSession,
    }),
    queryFn: async function deviceAgentConfigurationQueryFn(
      ctx,
    ): Promise<DeviceAgentConfigurationQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(agentGetConfiguration(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyDeviceAgentConfiguration(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "agent", "getConfiguration", parameters];
}
